import { PropsWithChildren } from 'react';
import { dialogModal } from '../../../../../styled-system/recipes';
import { DialogOverlay } from './DialogOverlay';

export const DialogModal = ({ children }: PropsWithChildren) => {
  return (
    <DialogOverlay>
      <dialog className={dialogModal()} open={true}>
        {children}
      </dialog>
    </DialogOverlay>
  );
};
